<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="values"
      :items-per-page="itemsPerPage"
      class="elevation-0"
      hide-default-footer
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('dtouch.welcomeForm.title', locale) }}</v-toolbar-title>
          <v-spacer />
            <v-btn
              color="primary"
              @click="handleDownload"
              style="margin: 10px 20px;"
            >
              CSV
            </v-btn>
          <search :onSearch="handleSearch" :showClear="true" />
          <v-btn
            color="primary"
            @click="handleGetData"
          >
            {{$t('dtouch.welcomeForm.refresh')}}
          </v-btn>
        </v-toolbar>
      </template>
    </v-data-table>
    <v-pagination
      v-if="totalPage && totalPage > 1"
      v-model="page"
      :length="totalPage"
      :total-visible="itemsPerPage"
      @input="handleGetData"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import apiWF from '@/services/apiWelcomeForm'
import search from '@/components/Search'
export default {
  components: {
    search,
  },
  data: () => ({
    searchValue: '',
    itemsPerPage: 20,
    totalPage: null, 
    page: 1,
    count: 0,
    values: [],
  }),
  computed: {
    ...mapState('app',['dtouchWorkspace', 'locale']),
    startIndex () {
      return (this.page -1) * this.itemsPerPage
    },
    headers () {
      return [
        {
          text: this.$t('dtouch.welcomeForm.name', this.locale),
          align: 'start',
          sortable: false,
          value: 'Name',
        },
        {
          text: this.$t('dtouch.welcomeForm.phone', this.locale),
          align: 'start',
          sortable: false,
          value: 'Phone',
        },
        {
          text: this.$t('dtouch.welcomeForm.email', this.locale),
          align: 'start',
          sortable: false,
          value: 'Email',
        },
        {
          align: 'start',
          sortable: false,
          value: 'sCD',
        },
      ]
    },
  },
  watch: {
    dtouchWorkspace () {
      this.handleGetData()
    },
  },
  mounted () {
    this.handleGetData()
  },
  methods: {
    handleSearch (v) {
      this.searchValue = v
      this.page = 1
      this.handleGetData()
    },
    handleGetData () {
      if (!this.dtouchWorkspace) return
      
      const filters = {
        startIndex: this.startIndex,
        itemsPerPage: this.itemsPerPage,
        searchValue: this.searchValue,
      }

      apiWF.getResult(this.dtouchWorkspace, filters)
        .then(response => {
          if (!response) return
          this.count = response.count
          this.totalPage = Math.ceil(this.count / this.itemsPerPage)
          this.values = response.data.map(item => {
            const aux =  item.CD.split('T')
            if (aux && aux.length === 2) {
              item.sCD = `${aux[0]}, ${aux[1].substring(0,8)}`
            }
            return item
          })
        })
        .catch(error => {
          console.log('jhm, err', error)
        }) 
    },
    handleDownload () {
      const objArray = this.values.map(item => {
        return {
          Name: item.Name,
          Phone: item.Phone,
          Email: item.Email,
          CD: item.CD,
        }
      })
      // downloadJSON2CSV
      var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray

      var str = ''

      for (var i = 0; i < array.length; i++) {
          var line = new Array()

          for (var index in array[i]) {
             line.push('"' + array[i][index] + '"')
          }

          str += line.join(';')
          str += '\r\n'
      }
      window.open( "data:text/csv;charset=utf-8," + encodeURIComponent(str))
    },
  },
}
</script>

